<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>项目</el-breadcrumb-item>
        <el-breadcrumb-item>调剂系统</el-breadcrumb-item>
        <el-breadcrumb-item>调剂推荐</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">调剂推荐</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="createDialog = true"
          >学员信息</el-button>
        </div>
      </div>
    </div>
   
     <div class="results card">
     <!-- <div class="table-header">
        <h3 class="title"></h3>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            fixed="left"
            align="center"
          ></el-table-column>
          <el-table-column
            label="推荐等级"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <el-rate
                v-model="scope.row.recommend_star"
                disabled
                text-color="#ff9900"
              >
              </el-rate>
            </template>
          </el-table-column>
          <el-table-column
            prop="category_ids"
            label="院校分类"
            width="260"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-tag
                size="mini"
                v-for="(item,index) in renderCategoryName(scope.row.category_ids)"
                :key="index"
              >{{item}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="province_name"
            label="地区"
            width="120px"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="college_name"
            label="院校名称"
            align="center"
            show-overflow-tooltip
            width="120px"
          >
          </el-table-column>
          <el-table-column
            label="专业名称"
            align="center"
            width="200px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              [{{ scope.row.major_code }}]{{ scope.row.major_name }}
            </template>
          </el-table-column>
          <el-table-column
            label="缺额详情"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="handleToDetail(scope.row,'2023')"
                :disabled="linkDisabled(scope.row,'2023')"
              >2023</el-link>
              <el-link
                type="primary"
                :underline="false"
                :disabled="linkDisabled(scope.row,'2022')"
                @click="handleToDetail(scope.row,'2022')"
              >2022</el-link>
              <el-link
                type="primary"
                :underline="false"
                :disabled="linkDisabled(scope.row,'2021')"
                @click="handleToDetail(scope.row,'2021')"
              >2021</el-link>
            </template>
          </el-table-column>

        </el-table>
      </div>-->
      <ReportDetail :uid="uid" :dataObj="results" :time="new Date()" />
    </div> 
    <RecommendStudentInfo
      :visible="createDialog"
      :provinces="filter.provinces"
      @close="createDialog=false"
      @submit="RecommendStudentInfoSubmit"

    ></RecommendStudentInfo>
    <AdjustDetail
      :visible="detailDialog"
      @close="detailDialog=false"
      :id="Number(detailId)"
      @submit="RecommendStudentInfoSubmit"
    ></AdjustDetail>
  </div>
</template>
  <script>


import RecommendStudentInfo from '@/components/dialog/adjust/RecommendStudentInfo.vue'
import AdjustDetail from '@/components/dialog/adjust/AdjustDetail.vue'
import { provinceList, collegeCategoryList ,recommendReportNoneUser} from '@/api/common'
import { reportDatalist } from "@/api/adjust";

import ReportDetail from "@/components/adjust/report/ReportDetail.vue";

export default {
  components: {
    RecommendStudentInfo,
    AdjustDetail,
    ReportDetail
  },
  data() {
    return {
      uid:'',
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      chooseList: [],
      createDialog: false,
      editDialog: false,
      editId: null,
      searchForm: {},
      categorys: [],
      detailDialog: false,
      detailId: null,
      filter: {
        provinces: []
      },
    };
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.start_create_time = this.$moment(value[0]).valueOf();
        this.query.end_create_time = this.$moment(value[1]).valueOf();
      } else {
        this.query.start_create_time = "";
        this.query.end_create_time = "";
        this.fetchList(true)
      }
    },
  },
  created() {
    this.$store.dispatch("getAllColleges");
    this.fetchCategoryList()
    this.fetchProvinceList()

  },
  mounted() {
    this.createDialog = true
  },
  methods: {
    // 省份列表请求
    fetchProvinceList() {
      provinceList().then(res => {
        this.filter.provinces = res.list
        this.provinces = res.list
         this.provinces.unshift({
          name: "二区",
          code: "15,45,46,52,53,54,62,63,64,65",
        });
        this.provinces.unshift({
          name: "一区",
          code: "11,12,13,14,21,22,23,31,32,33,34,35,36,37,41,42,43,44,50,51,61",
        });
        this.provinces.unshift({
          name:'不限',
          code:'null'
        })
      })
    },
    fetchCategoryList() {
      collegeCategoryList({ isPaging: 0 }).then(res => {
        this.categorys = res.list
      })
    },
    fetchList(isReset = false) {
      // if (isReset) {
      //   this.$set(this.query, "pageIndex", 1);
      // }
      // const params = Object.assign({}, this.query, {
      //   ...this.searchForm
      // });
       const params = this.searchForm
      if (params.college_category_ids) {
        params.college_category_ids = params.college_category_ids.join(',')
      }
      // if (params.mind_college_province_codes) {
      //   params.mind_college_province_codes = params.mind_college_province_codes.join(',')
      // }

      recommendReportNoneUser(params).then((res) => {
        this.results = res
        // this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },


    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
      if (this.query.college_category_ids && this.query.college_category_ids.length) {
        this.query.college_category_ids = this.query.college_category_ids.split(",").map(v => { return Number(v) });
      }
      if (this.query.mind_college_province_codes && this.query.mind_college_province_codes.length) {
        this.query.mind_college_province_codes = this.query.mind_college_province_codes.split(",").map(v => { return Number(v) });
      }
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query);
      let isSync = Object.keys(params).some(
        (key) => this.$route.query[key] != params[key]
      );
      if (params.college_category_ids) {
        params.college_category_ids = params.college_category_ids.filter((v) => v).join(",");
      }
      if (params.mind_college_province_codes) {
        params.mind_college_province_codes = params.mind_college_province_codes.filter((v) => v).join(",");
      }
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, params),
        });
    },
    handleToEdit(row) {
      this.editId = row.id
      this.editDialog = true
    },
    RecommendStudentInfoSubmit({ data }) {
      this.searchForm = data
    
      this.fetchList(true)
    },
    // 分类名称渲染
    renderCategoryName(ids) {
      if (!ids) {
        return []
      }
      ids = ids.split(',')
      const list = this.categorys.filter(item => ids.includes(String(item.id)))
      if (list.length) {
        return list.map(v => v.name)
      }
      return []
    },
    linkDisabled(row, year) {
      let res = new Map()
      let arr = row.id_year_plan_last_counts.split(',').filter((v) => !res.has(v.split('-')[1]) && res.set(v.split('-')[1], 1))
      if (arr.findIndex(v => { return v.split('-')[1] == year }) != -1) {
        return false
      } else {
        return true
      }
    },
    handleToDetail(row, year) {
      let res = new Map()
      let arr = row.id_year_plan_last_counts.split(',').filter((v) => !res.has(v.split('-')[1]) && res.set(v.split('-')[1], 1))
      this.detailId = arr.find(v => { return v.split('-')[1] == year }).split('-')[0]
      this.detailDialog = true
    }
  },
};
    </script>
    
    <style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
.el-tag {
  margin: 0px 5px;
}
.tag-wrap {
  text-align: left;
}
</style>
    